export interface GranularityOption<T extends string> {
    key: T;
    label: string;
}

interface GranularityToggleProps<T extends string> {
    value: T;
    options: GranularityOption<T>[];
    onChange: (next: T) => void;
    ariaLabel: string;
}

// Small rounded-full segmented control - shared shell behind every
// granularity toggle in Accounts (calls insights, patient insights), each
// supplying its own option set and value type.
export function GranularityToggle<T extends string>({
    value,
    options,
    onChange,
    ariaLabel
}: GranularityToggleProps<T>) {
    return (
        <div
            className="flex items-center gap-0.5 bg-gray-100 rounded-full p-0.5"
            role="group"
            aria-label={ariaLabel}
        >
            {options.map((option) => (
                <button
                    key={option.key}
                    type="button"
                    aria-pressed={value === option.key}
                    onClick={() => onChange(option.key)}
                    className={`px-2.5 h-6 rounded-full text-[11px] font-semibold transition-colors ${
                        value === option.key
                            ? 'bg-white shadow-sm text-gray-900'
                            : 'text-gray-500 hover:text-gray-700'
                    }`}
                >
                    {option.label}
                </button>
            ))}
        </div>
    );
}
